import { Helmet } from '@dr.pogodin/react-helmet';
import { config } from '@iheartjane/config';

interface Props {
  description: string;
  image?: string;
  isBoostForAll: boolean;
  /** Omit references to Jane on partner hosted sites */
  isPartnerHosted?: boolean;
  /** Boost runtime config: the partner supplies their own description */
  skipDescription?: boolean;
  /** Boost runtime config: the partner supplies their own title */
  skipTitle?: boolean;
  title: string;
  type?: string;
  url: string;
}

export const OpenGraph = ({
  title,
  description,
  image,
  url,
  type = 'website',
  isBoostForAll,
  isPartnerHosted = false,
  skipDescription = false,
  skipTitle = false,
}: Props) => {
  /** Note: using fragments prevents the tags from rendering */
  return (
    <Helmet>
      {/** Title and description metadata */}
      {!skipTitle && <meta property="og:title" content={title} />}
      {!skipDescription && (
        <meta property="og:description" content={description} />
      )}

      {/** Url & product description metadata is set in boost4all controller https://github.com/janetechinc/iheartjane/blob/b36d47cefe38578e391ecdd3d33addf12bd1f425/api/app/lib/boost/compilation/compile.rb#L35 */}
      {!isBoostForAll && <meta property="og:url" content={url} />}

      {!skipTitle && <meta name="twitter:title" content={title} />}
      {!skipDescription && (
        <meta name="twitter:description" content={description} />
      )}

      {/** Image metadata, separate from the title & description checks */}
      {image && <meta property="og:image" content={image} />}
      {image && <meta name="twitter:image" content={image} />}

      {/** Jane references */}
      {!isPartnerHosted && <meta property="og:site_name" content="Jane" />}
      {!isPartnerHosted && (
        <meta property="fb:app_id" content={config.facebookAppId} />
      )}
      {!isPartnerHosted && (
        <meta name="twitter:creator" content="@_iheartjane" />
      )}
      {!isPartnerHosted && <meta name="twitter:site" content="@_iheartjane" />}

      {/** Default metadata */}
      <html
        lang="en"
        // eslint-disable-next-line react/no-unknown-property
        prefix="og: http://ogp.me/ns# fb: http://ogp.me/ns/fb# product: http://ogp.me/ns/product#"
      />
      <meta property="og:type" content={type} />
      <meta property="og:locale" content="en_US" />
      <meta
        name="twitter:card"
        content={image ? 'summary_large_image' : 'summary'}
      />
    </Helmet>
  );
};
